import * as React from 'react'

import { useAdminCompanyPayoutsQuery } from './generated';
import { Payouts as PayoutsBase } from '../shared';

export function Payouts() {
  return <PayoutsBase query={useAdminCompanyPayoutsQuery} to='/admin2/providers' />
}